import script from "./Origin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Origin.vue?vue&type=script&setup=true&lang=ts"

import "./Origin.vue?vue&type=style&index=0&id=3fe41ced&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe41ced"]])

export default __exports__